export default __webpack_public_path__ + "static/media/ve.e644e482.svg";